import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ChangeIssueStatusController', ChangeIssueStatusController);

    /** @ngInject */
    function ChangeIssueStatusController(
        $rootScope,
        $scope,
        $state,
        $stateParams,
        CompanyFactory,
        CompaniesFactory,
        toastr,
        ngDialog
    ) {
        var vm = this;

        init();

        function init() {
            vm.save = save;
            vm.issue = angular.copy($scope.ngDialogData.issue);
            vm.companyId = angular.copy($scope.ngDialogData.company);
            vm.openAssignToDialog = openAssignToDialog;

            getCompanySettings();
        }

        function getCompanySettings() {
            CompanyFactory.readCompany().then(function (response) {
                if (response.data.manager) {
                    vm.statusesList = [
                        { name: 'Przekazano', value: 'forwarded' },
                        { name: 'Przyjęto', value: 'inprogress' },
                        { name: 'Częściowo zrealizowano', value: 'partlyfixed' },
                        { name: 'Zrealizowano', value: 'fixed' },
                        { name: 'Odrzucono', value: 'rejected' },
                    ];
                } else {
                    vm.statusesList = [
                        { name: 'Przyjmij', value: 'inprogress' },
                        { name: 'Rozwiąż częściowo', value: 'partlyfixed' },
                        { name: 'Zrealizuj', value: 'fixed' },
                        { name: 'Odrzuć', value: 'rejected' },
                    ];
                }

                CompaniesFactory.readCompanies(vm.companyId).then(function (
                    companySettings
                ) {
                    if (companySettings.data.estimate_status) {
                        vm.statusesList.push({
                            name: 'Kosztorys',
                            value: 'estimate',
                        });
                    }
                    if (companySettings.data.invoiced_status) {
                        vm.statusesList.push({
                            name: 'Zafakturowano',
                            value: 'invoiced',
                        });
                    }
                });
            });
        }

        function editIssue(should_change_contractor_event) {
            CompaniesFactory.editIssue(vm.companyId, vm.issue.id, {
                status: vm.issue.status,
            }).then(function (response) {
                $rootScope.$emit('emitThisIssue', response.data);
                toastr.success('Status został zmieniony.');
                $state.reload('company_employee.issue_list.details');
                ngDialog.close();

                if (should_change_contractor_event) {
                    openAssignToDialog();
                }
            });
        }

        function assignMe() {
            CompaniesFactory.assignMe(vm.companyId, $stateParams.issue_id).then(
                function (response) {
                    $state.reload('company_employee.issue_list.details');
                    $rootScope.$emit('emitThisIssue', response.data);
                    toastr.success('Status został zmieniony.');
                    ngDialog.close();
                }
            );
        }

        function addJournalEntry(callback) {
            if (!vm.journalEntry) {
                toastr.error('Wypełnij powód odrzucenia.');
                return;
            }

            CompaniesFactory.addToJournal(vm.companyId, $stateParams.issue_id, {
                notes: vm.journalEntry,
            }).then(function () {
                if (callback) {
                    callback();
                }
            });
        }

        function openAssignToDialog() {
            ngDialog.open({
                template:
                    'changeContractorDialog',
                controller: 'ChangeContractorEmployeeController',
                controllerAs: 'ChangeContractorEmployeeCtrl',
                className: 'dialog-theme',
                data: {
                    issue: vm.issue,
                    company: vm.companyId,
                },
            });
        }

        function save() {
            if (vm.issue.status === 'inprogress' && !vm.issue.assigned_to) {
                assignMe();
                return;
            }

            if (vm.issue.status === 'forwarded') {
                editIssue(true);
                return;
            }

            if (vm.issue.status === 'rejected') {
                addJournalEntry(editIssue);
                return;
            }

            editIssue(false);
            return;
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/change_status_dialog/change_status.controller.ts